import React from 'react';
import PropTypes from 'prop-types';

import ButtonPush from '../button/button-push'

class InputCheckbox extends React.Component {
    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        value: PropTypes.bool.isRequired,
        className: PropTypes.string,
        iconDisabled: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func.isRequired
    }

    state = {
        value: this.props.value
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.value !== this.state.value) {
            this.setState({value: nextProps.value})
        }
    }

    onClick() {
        this.props.onClick()
        this.setState({value: !this.state.value})
    }

    render() {
        const {value} = this.state
        let {className} = this.props

        className = className ? className + ' inline' : 'inline'

        return <ButtonPush className={className}
            disabled={this.props.disabled}
            value={value}
            onClick={this.onClick.bind(this)}
            label={this.props.label}
            iconOn="checkboxChecked"
            iconOff="checkboxUnchecked"/>
    }
}

export default InputCheckbox

